import PropTypes from 'prop-types';
import {createUseStyles, useTheme} from 'react-jss';
import {connect} from 'react-redux';
import loadArtemisFonts from '../../../../v2/components/ui/loadArtemisFonts';
import Translation from '../../../../v2/lang/Translation';
import isUsingArtemisStyles from '../../../../v2/selectors/isUsingArtemisStyles';
import Typography from '../../../../v2/style-helper/Typography';

const useStyles = createUseStyles({
  verifyAccount: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    minHeight: 200,
    padding: 20,
  },

  title: {
    fontSize: 14,
    fontWeight: 'bold',
    extend: props => ({
      ...(props.isUsingArtemisStyles && props.theme.typography?.[Typography.body])
      && loadArtemisFonts(props.theme.typography[Typography.body], true),
    }),
  },

  instructions: {
    lineHeight: 1.5,
    letterSpacing: 0.2,
  },
});

export function VerifyAccount(props) {
  const theme = useTheme();
  const classes = useStyles({...props, theme});
  return (
    <div className={classes.verifyAccount} data-test="VerifyAccount">
      <p className={classes.title} data-test="VerifyAccount__title">
        <Translation>verify.your.email</Translation>
      </p>
      <span className={classes.instructions} data-test="VerifyAccount__instructions" data-cs-mask>
        <Translation placeholderValues={[props.emailAddress]}>
          email.verification.instructions.bold
        </Translation>
      </span>
    </div>
  );
}

const mapStateToProps = state => ({
  emailAddress: state.start.customer.email,
  isUsingArtemisStyles: isUsingArtemisStyles(state),
});

VerifyAccount.propTypes = {
  emailAddress: PropTypes.string.isRequired,
  isUsingArtemisStyles: PropTypes.bool,
};

export default connect(mapStateToProps)(VerifyAccount);
